// extracted by mini-css-extract-plugin
export default {"createLearningObjective":"create-learning-objective_createLearningObjective__qLWcX","createLearningObjectiveTitle":"create-learning-objective_createLearningObjectiveTitle__CQ2Zp"};